/** Karte eines Abschnitts: Nummer, Titel und ein Marker „geändert“ oder „Fehler“ – immer offen. */
import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { MARKER_TEXT } from './ConfigurationSectionNavigation';
import {
  SECTION_TITLE,
  sectionAnchor,
  sectionNumber,
  type SectionKey,
  type SectionMarker,
} from './configurationSections';

export function ConfigurationSection({
  section,
  marker,
  children,
}: {
  section: SectionKey;
  marker: SectionMarker;
  children: ReactNode;
}) {
  const anchor = sectionAnchor(section);
  return (
    <section
      id={anchor}
      aria-labelledby={`${anchor}-title`}
      className="bg-card border-hairline rounded-tile flex min-w-0 scroll-mt-4 flex-col gap-3 border px-4 py-5 md:px-[22px]"
    >
      <h2
        id={`${anchor}-title`}
        tabIndex={-1}
        className="flex flex-wrap items-center gap-2.5 font-serif text-[22px] font-bold tracking-[-0.02em] outline-none"
      >
        <span className="bg-forest-deep grid size-[30px] flex-none place-items-center rounded-full font-sans text-sm font-extrabold text-white">
          {sectionNumber(section)}
        </span>
        <span className="min-w-0">{SECTION_TITLE[section]}</span>
        {marker && (
          <span
            className={cn(
              'rounded-pill flex h-6 items-center px-2.5 font-sans text-[11px] font-bold tracking-normal',
              marker === 'error' ? 'bg-sealwax-tint text-sealwax' : 'bg-amber-tint text-amber-ink',
            )}
          >
            {MARKER_TEXT[marker]}
          </span>
        )}
      </h2>
      {children}
    </section>
  );
}
